/*
 * jQuery myCart - v1.9 - 2020-12-03
 * http://asraf-uddin-ahmed.github.io/
 * Copyright (c) 2017 Asraf Uddin Ahmed; Licensed None
 */

(function ($) {

  "use strict";

  var OptionManager = (function () {
    var objToReturn = {};

    var _options = null;
    var DEFAULT_OPTIONS = {
      currencySymbol: '$',
      classCartIcon: 'my-cart-icon',
      classCartBadge: 'my-cart-badge',
      classProductQuantity: 'my-product-quantity',
      classProductRemove: 'my-product-remove',
      classCheckoutCart: 'my-cart-checkout',
      affixCartIcon: true,
      showCheckoutModal: true,
      numberOfDecimals: 2,
      cartItems: null,
      clickOnAddToCart: function ($addTocart) {},
      afterAddOnCart: function (products, totalPrice, totalQuantity) {},
      clickOnCartIcon: function ($cartIcon, products, totalPrice, totalQuantity) {},
      checkoutCart: function (products, totalPrice, totalQuantity) {
        return false;
      },
      getDiscountPrice: function (products, totalPrice, totalQuantity) {
        return null;
      }
    };

    var loadOptions = function (customOptions) {
      _options = $.extend({}, DEFAULT_OPTIONS);
      if (typeof customOptions === 'object') {
        $.extend(_options, customOptions);
      }
    };
    var getOptions = function () {
      return _options;
    };

    objToReturn.loadOptions = loadOptions;
    objToReturn.getOptions = getOptions;
    return objToReturn;
  }());

  var MathHelper = (function () {
    var objToReturn = {};
    var getRoundedNumber = function (number) {
      if (isNaN(number)) {
        throw new Error('Parameter is not a Number');
      }
      number = number * 1;
      var options = OptionManager.getOptions();
      return number.toFixed(options.numberOfDecimals);
    };
    objToReturn.getRoundedNumber = getRoundedNumber;
    return objToReturn;
  }());

  var ProductManager = (function () {
    var objToReturn = {};

    const STORAGE_NAME = "__mycart";
    localStorage[STORAGE_NAME] = localStorage[STORAGE_NAME] ? localStorage[STORAGE_NAME] : "";
    var getIndexOfProduct = function (id) {
      var productIndex = -1;
      var products = getAllProducts();
      $.each(products, function (index, value) {
        if (value.id == id) {
          productIndex = index;
          return;
        }
      });
      return productIndex;
    };
    var setAllProducts = function (products) {
      localStorage[STORAGE_NAME] = JSON.stringify(products);
    };
    var addProduct = function (id, name, quantity, image) {  // Updated to include image
      var products = getAllProducts();
      products.push({
        id: id,
        name: name,
        quantity: quantity,
        image: image  // Added image
        // price: price,   // Commented out price
        // summary: summary // Commented out summary
      });
      setAllProducts(products);
    };

    /*
    PUBLIC
    */
    var getAllProducts = function () {
      try {
        var products = JSON.parse(localStorage[STORAGE_NAME]);
        return products;
      } catch (e) {
        return [];
      }
    };
    var updatePoduct = function (id, quantity) {  // Updated to only update quantity
      var productIndex = getIndexOfProduct(id);
      if (productIndex < 0) {
        return false;
      }
      var products = getAllProducts();
      products[productIndex].quantity = quantity * 1; // Only update quantity
      setAllProducts(products);
      return true;
    };
    var setProduct = function (id, name, quantity, image) {  // Updated to include image
      if (typeof id === "undefined") {
        console.error("id required");
        return false;
      }
      if (typeof name === "undefined") {
        console.error("name required");
        return false;
      }
      if (!$.isNumeric(quantity)) {
        console.error("quantity is not a number");
        return false;
      }

      if (!updatePoduct(id, quantity)) {
        addProduct(id, name, quantity, image); // Updated to add image as well
      }
    };
    var clearProduct = function () {
      setAllProducts([]);
    };
    var removeProduct = function (id) {
      var products = getAllProducts();
      products = $.grep(products, function (value, index) {
        return value.id != id;
      });
      setAllProducts(products);
    };
    var getTotalQuantity = function () {
      var total = 0;
      var products = getAllProducts();
      $.each(products, function (index, value) {
        total += value.quantity * 1;
      });
      return total;
    };

    objToReturn.getAllProducts = getAllProducts;
    objToReturn.updatePoduct = updatePoduct;
    objToReturn.setProduct = setProduct;
    objToReturn.clearProduct = clearProduct;
    objToReturn.removeProduct = removeProduct;
    objToReturn.getTotalQuantity = getTotalQuantity;
    return objToReturn;
  }());


  var loadMyCartEvent = function (targetSelector) {

    var options = OptionManager.getOptions();
    var $cartIcon = $("." + options.classCartIcon);
    var $cartBadge = $("." + options.classCartBadge);
    var classProductQuantity = options.classProductQuantity;
    var classProductRemove = options.classProductRemove;
    var classCheckoutCart = options.classCheckoutCart;

    var idCartModal = 'my-cart-modal';
    var idCartTable = 'my-cart-table';
    var idGrandTotal = 'my-cart-grand-total';
    var idEmptyCartMessage = 'my-cart-empty-message';
    var classProductTotal = 'my-product-total';
    var classAffixMyCartIcon = 'my-cart-icon-affix';

    if (options.cartItems && options.cartItems.constructor === Array) {
      ProductManager.clearProduct();
      $.each(options.cartItems, function () {
        ProductManager.setProduct(this.id, this.name, this.quantity, this.image); // Updated to include image
      });
    }

    $cartBadge.text(ProductManager.getTotalQuantity());

    if(ProductManager.getTotalQuantity() == 0) $('#cartIcon').hide()

    if (!$("#" + idCartModal).length) {
      $('body').append(
        '<div class="modal fade rental-service" id="' + idCartModal + '" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">' +
        '<div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">' +
        '<div class="modal-content">' +
        '<div class="modal-header justify-content-between p-0">' +
        '<h5 class="modal-title p-3" id="exampleModalLabel">My cart!!</h5>' +
        '<button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">' +
        '<i class="fa-solid fa-xmark"></i>' +
        ' </button>' +
        '</div>' +
        '<div class="modal-body">' +
        '<table class="table table-hover table-responsive" id="' + idCartTable + '"></table>' +
        '</div>' +
        '<div class="modal-footer justify-content-around">' +
        '<button type="button" class="btn btn-primary ' + classCheckoutCart + '">Checkout</button>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>'
      );
    }

    var drawTable = function () {
      var $cartTable = $("#" + idCartTable);
      $cartTable.empty();

      var products = ProductManager.getAllProducts();
      $.each(products, function () {
        var total = this.quantity * 1; // Updated to only calculate based on quantity
        $cartTable.append(
          '<tr title="' + this.name + '" data-id="' + this.id + '">' +
          '<td class="text-center" style="width: 30px;"><img width="80px" height="80px" src="' + this.image + '"/></td>' +  // Display image
          '<td>' + this.name + '</td>' +
          '<td title="Quantity"><input type="number" min="1" style="width: 70px;" class="form-control ' + classProductQuantity + '" oninput="validity.valid||(value=``);" value="' + this.quantity + '" /></td>' +
          '<td title="Remove from Cart" class="text-center" style="width: 30px;"><a href="javascript:void(0);" class="btn btn-xs btn-danger close  ' + classProductRemove + '"><i class="fa-solid fa-xmark"></i></a></td>' +
          '</tr>'
        );
      });

      $cartTable.append(products.length ?
        '<tr>' +
        '<td></td>' +
        '<td></td>' +
        '<td></td>' +
        '<td></td>' +
        '</tr>' :
        '<div class="alert alert-danger" role="alert" id="' + idEmptyCartMessage + '">Your cart is empty</div>'
      );
    };

    var showModal = function () {
      drawTable();
      $("#" + idCartModal).modal('show');
    };

    $cartIcon.click(function () {
      options.showCheckoutModal ? showModal() : options.clickOnCartIcon($cartIcon, ProductManager.getAllProducts());
    });

    $(document).on("input", "." + classProductQuantity, function () {
      var id = $(this).closest("tr").data("id");
      ProductManager.updatePoduct(id, $(this).val());
      $cartBadge.text(ProductManager.getTotalQuantity());
    });

    $(document).on('click', "." + classProductRemove, function () {
      var $tr = $(this).closest("tr");
      var id = $tr.data("id");
      $('.img-blk').find(`button[data-id="${id}"]`).closest('.img-blk').removeClass('active')
      $('.img-blk').find(`button[data-id="${id}"]`).text('Add to Cart')

      $tr.hide(500, function () {
        ProductManager.removeProduct(id);
        drawTable();
        if(ProductManager.getTotalQuantity() == 0) $('#cartIcon').hide()
        $cartBadge.text(ProductManager.getTotalQuantity());
      });
    });

    $('.my-cart-btn').on('click', targetSelector, function () {
      $('#cartIcon').show()

      if($(this).text() == 'Added') {
        $('#message').text('Item Already added').show()

        setTimeout(() => {
          $('#message').hide();
        }, 2000);

        return;
      }

      var $target = $(this);
      options.clickOnAddToCart($target);
      var id = $target.data('id');
      var name = $target.data('name');
      var quantity = $target.data('quantity');
      var image = $target.data('image');  // Added image
      ProductManager.setProduct(id, name, quantity, image);  // Updated to include image
      $cartBadge.text(ProductManager.getTotalQuantity());
      options.afterAddOnCart(ProductManager.getAllProducts(), ProductManager.getTotalQuantity());

      $(this).text('Added')
      $('.img-blk').find(`button[data-id="${id}"]`).closest('.img-blk').addClass('active')
      $('.img-blk').find(`button[data-id="${id}"]`).text('Added')
      $('#message').text('Item Added to Cart').show()

      setTimeout(() => {
        $('#message').hide();
      }, 2000);
    });
  };


  $.fn.myCart = function (userOptions) {
    OptionManager.loadOptions(userOptions);
    loadMyCartEvent(this.selector);
    return this;
  };


})(jQuery);
